import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import { pathSegments } from "../../utils/pathRules";

export interface ExplorerBreadcrumbsProps {
  rootLabel: string;
  /** The current top-level folder's label, or null at the explorer root (no breadcrumbs shown then). */
  folderLabel: string | null;
  /** ADR 0010: the subfolder path under `folderLabel`, "" at its own root. */
  path: string;
  onNavigateRoot: () => void;
  /** Navigates to `folderLabel`'s own root (path=""). */
  onNavigateFolder: () => void;
  /** Navigates to an ancestor subfolder path (every segment up to and including the clicked one). */
  onNavigatePath: (path: string) => void;
}

/**
 * "Your Files > LEEFT_TO_PARTNER > a > b" above the table (ADR 0010: every
 * segment is clickable except the last), shown only inside a folder.
 */
export function ExplorerBreadcrumbs({
  rootLabel,
  folderLabel,
  path,
  onNavigateRoot,
  onNavigateFolder,
  onNavigatePath,
}: ExplorerBreadcrumbsProps) {
  if (!folderLabel) {
    return null;
  }
  const segments = pathSegments(path);
  const isLastFolderLabel = segments.length === 0;

  return (
    <Breadcrumbs aria-label="Breadcrumb" sx={{ mb: 2 }}>
      <Link component="button" type="button" underline="hover" color="inherit" onClick={onNavigateRoot}>
        {rootLabel}
      </Link>
      {isLastFolderLabel ? (
        <Typography color="text.primary">{folderLabel}</Typography>
      ) : (
        <Link component="button" type="button" underline="hover" color="inherit" onClick={onNavigateFolder}>
          {folderLabel}
        </Link>
      )}
      {segments.map((segment, index) => {
        const isLast = index === segments.length - 1;
        const segmentPath = segments.slice(0, index + 1).join("/");
        return isLast ? (
          <Typography key={segmentPath} color="text.primary">
            {segment}
          </Typography>
        ) : (
          <Link
            key={segmentPath}
            component="button"
            type="button"
            underline="hover"
            color="inherit"
            onClick={() => onNavigatePath(segmentPath)}
          >
            {segment}
          </Link>
        );
      })}
    </Breadcrumbs>
  );
}
